export default "<p>rma-shipping-arrivals-detail works!</p>\n"